import React from "react";
import { Col, Row } from "react-bootstrap";
import classes from "./About.module.css";
import Fade from "react-reveal/Fade";
import {
  Facebook,
  GitHub,
  Instagram,
  LinkedIn,
  Mail,
} from "@material-ui/icons";
import { IconButton, makeStyles } from "@material-ui/core";

const useClasses = makeStyles((theme) => ({
  iconContainerGit: {
    "&:hover $icon": {
      color: "#2987de",
    },
  },
  iconContainerInsta: {
    "&:hover $icon": {
      color: "#fa0032",
    },
  },
  iconContainerFb: {
    "&:hover $icon": {
      color: "#17a7fc",
    },
  },
  iconContainerLinked: {
    "&:hover $icon": {
      color: "#0a66c2",
    },
  },
  icon: {
    color: "#4b5769",
    fontSize: 30,
  },
}));
const About = () => {
  const styles = useClasses();
  return (
    <div className="d-flex justify-content-center ">
      <Row className="w-75">
        <Col md="6">
          <div className={classes.shape}></div>
          <Fade appear={true} spy={true} left>
            <h2>
              <small className={classes.smallTxt}>I'm </small>
              Shahriar Saleh
            </h2>
            <p style={{ fontSize: "1.3rem" }}>
              Enthusiastic React.js developer with broad expertise in
              Javascript/ES6 and willing to learn and master Back-end
              Development. Looking for a challenging yet exciting career with a
              progressive company that will provide development opportunities.
            </p>
            <div className={classes.btn}>
              <a
                href="https://drive.google.com/file/d/1Wx4DPqw-uEyJbH1bsdiHwEOblsEifCRc/view?usp=sharing"
                target="blank"
              >
                <span>View Resume</span>
              </a>
            </div>
            <div className="mt-5 mb-4">
              <a
                style={{ textDecoration: "none" }}
                href="https://github.com/Fahim04blue"
                target="_blank"
              >
                <IconButton className={styles.iconContainerGit}>
                  <GitHub className={styles.icon} />
                </IconButton>{" "}
              </a>
              <a
                style={{ textDecoration: "none" }}
                href="https://www.instagram.com/shahriarfahim04/"
                target="_blank"
              >
                <IconButton className={styles.iconContainerInsta}>
                  <Instagram className={styles.icon} />{" "}
                </IconButton>
              </a>
              <a
                style={{ textDecoration: "none" }}
                href="https://www.facebook.com/shahriar.fahim.7"
                target="_blank"
              >
                <IconButton className={styles.iconContainerFb}>
                  <Facebook className={styles.icon} />{" "}
                </IconButton>
              </a>
              <a
                style={{ textDecoration: "none" }}
                href="https://www.linkedin.com/in/shahriarfahim04/"
                target="_blank"
              >
                <IconButton className={styles.iconContainerLinked}>
                  <LinkedIn className={styles.icon} />{" "}
                </IconButton>
              </a>
            </div>
          </Fade>
        </Col>
        <Col md="6">
          <Fade appear={true} spy={true} right>
            <div className="my-5 " style={{ marginLeft: "4%" }}>
              <h1 style={{ color: "#fa0032", fontSize: "2.5rem" }}>
                Key Skills
              </h1>
              <h4 style={{ fontSize: "1.8rem" }}>Expertise:</h4>
              <div className={classes.technology}>
                <span>JavaScript</span>
                <span>ES6</span>
                <span>React.js</span>
                <span>React Router</span>
                <span>HTML5</span>
                <span>CSS3</span>
                <span>Bootstrap</span>
                <span>Material UI</span>
              </div>
              <h4 style={{ fontSize: "1.8rem", marginTop: "5%" }}>Familiar:</h4>
              <div className={classes.technology}>
                <span>Node.js</span>
                <span>Express.js</span>
                <span>MongoDB</span>
                <span>Mongoose</span>
                <span>React Bootstrap</span>
                <span>React Chartjs 2</span>
                <span>React Leaflet</span>
                <span>CDB React</span>
                <span>Numeral.js</span>
                <span>Stripe.js</span>
                <span>React Slick</span>
                <span>React Scroll</span>
              </div>
              <h4 style={{ fontSize: "1.8rem", marginTop: "5%" }}>Tools:</h4>
              <div className={classes.technology}>
                <span>Git</span>
                <span>Firebase</span>
                <span>Netlify</span>
                <span>Heroku</span>
                <span>Chrome Dev Tools</span>
                <span>VS Code</span>
                <span>Figma</span>
                <span>Adobe Photoshop</span>
              </div>
            </div>
          </Fade>
        </Col>
      </Row>
    </div>
  );
};

export default About;
